import React,{useState, useEffect, useRef} from "react";
import DummyProfile from '../Assets/dummyprofile.png';
import UploadIcon from "../Assets/uploadIcon.svg";
import deleteIcon from "../Assets/deleteIcon.svg";
import { GetLocalStorage } from "../../../../Helpers/LocalStorage/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { FetchInstituteData } from "../../../../Actions/StudentA";
import { BaseUrl } from "../../../../Actions/Base";
import ReuseablePopup from "../../../../Components/ReuseablePopups/ReuseablePopup";


const InstituteDetails = () => {
 const Border = "border-[#E2E2E2] border-[1px] border-solid";

 const Dispatch = useDispatch();

  const [isUpdatedPopup, setIsUpdatedPopup] = useState(false);
  const [isDeletingPopup, setIsDeletingPopup] = useState(false);
  const [isDeletingIconPopup, setIsDeletingIconPopup] = useState(false);

  const [tempImageFile, setTempImageFile] = useState(null);
  const [tempIconFile, setTempIconFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isUploadingIcon, setIsUploadingIcon] = useState(false);

  
  const [formData, setFormData] = useState({
    phone: '0123123456789',
    email: 'email@gmail.com',
    country: 'Canada',
    province: 'Ontario',
    city: 'Toronto',
    postalCode: 'A1B 1A2',
    address:'',
    InstituteLogo:'',
    InstituteIcon:'',
    InstituteBanner:'',
    Youtube:'https//:Youtube/zamn',
    Tiktok:'https//:tiktok/',
    Facebook:'https//:Facebook.com/',
    Instagram:'https//:Instagram.com/',
    BussinessName:''
  });

  const [originalData, setOriginalData] = useState({
    Youtube: '',
    Tiktok: '',
    Facebook: '',
    Instagram: '',
  });
  
  const [previousImageUrl, setPreviousImageUrl] = useState(formData.imgUrl);
  const fileInputRef = useRef();
  const tempImageFileRef = useRef(null);
  const iconInputRef = useRef(null);

  const InstituteId = GetLocalStorage("UserInfo")?.Institute?.InstituteId;
  console.log("InstituteId in SchoolTimingsAndSchedule is:",InstituteId);

  const { InstituteDetails } = useSelector((Store) => Store.StudentReducer);
  console.log("InstituteDetails are:",InstituteDetails)

  useEffect(() => {
    if(InstituteId){
        Dispatch(FetchInstituteData(InstituteId))
    }
  }, [InstituteId]);

  useEffect(() => {
    if (InstituteDetails) {
      const { InstituteData, userData } = InstituteDetails;

    const youtube = InstituteData?.Youtube || '';
    const tiktok = InstituteData?.Tiktok || '';
    const facebook = InstituteData?.Facebook || '';
    const instagram = InstituteData?.Instagram || '';

  
      setFormData(prev => ({
        ...prev,
        phone: userData?.PhoneNumber || '',
        email: userData?.Email || '',
        country: InstituteData?.Country || '',
        province: InstituteData?.State || '',
        city: InstituteData?.City || '',
        postalCode: InstituteData?.PostalCode || '',
        address: InstituteData?.Address || '',
        BussinessName: InstituteData?.InstituteName || '',
        InstituteLogo:  `${BaseUrl}/api/images/InstituteLogo?url=${InstituteData?.InstituteLogo || ''}`,
        InstituteIcon:  `${BaseUrl}/api/images/InstituteBanner?url=${InstituteData?.InstituteIcon || ''}`,
        InstituteBanner:  `${BaseUrl}/api/images/InstituteBanner?url=${InstituteData?.Institute_Banner || ''}`,
        Youtube: youtube,
        Tiktok: tiktok,
        Facebook: facebook,
        Instagram: instagram,
      }));

      setOriginalData({
        Youtube: youtube,
        Tiktok: tiktok,
        Facebook: facebook,
        Instagram: instagram,
      });
    }
  }, [InstituteDetails]);
  
   
    const handleDeleteImage = () => {
        setFormData((prev) => ({
          ...prev,
          InstituteLogo: "", // Clear image
        }));

        setIsDeletingPopup(false)
      };
    
    const handleToggleImageUpload = () => {
      if (!isUploadingImage) {
        setPreviousImageUrl(formData.InstituteLogo);
        setIsUploadingImage(true);
        // Reset the file input value
        fileInputRef.current.value = ''; // Reset the file input
        // Trigger file input click
        fileInputRef.current.click();
      } else {
        // Cancel upload and reset the state to previous image
        setFormData((prev) => ({
          ...prev,
          InstituteLogo: `${BaseUrl}/api/images/InstituteLogo?url=${InstituteDetails?.InstituteLogo}`,
        }));
        setTempImageFile(null);
        setIsUploadingImage(false);
      }
    };
    
    const handleImageSelection = (e) => {
      const file = e.target.files[0];
      if (file) {
        tempImageFileRef.current = file; // ✅ Immediate update
        const previewUrl = URL.createObjectURL(file);
        console.log("previewUrl is:",previewUrl)
        setFormData((prev) => ({
          ...prev,
          InstituteLogo: previewUrl,
        }));
      }
    
      // Clear input so same file can be reselected
      e.target.value = null;
    };
       
    const handleConfirmUpload = async () => {
      const file = tempImageFileRef.current;
      if (!file) {
        console.log("No file to upload.");
        return;
      }
    
      try {
        const formData = new FormData();
        formData.append("InstituteLogo", file);
    
        const response = await fetch(`${BaseUrl}/api/NewInstitute/UpdateInstituteLogoImages/${InstituteId}`, {
          method: "POST",
          body: formData,
        });
    
        const result = await response.json();
    
        if (response.ok) {
          // Save image URL to local state for UI display
          setFormData((prev) => ({
            ...prev,
            InstituteLogo: `${BaseUrl}/api/images/InstituteLogo?url=${result.path}`,
          }));
    
          setIsUploadingImage(false);
          setTempImageFile(null);
          setIsUpdatedPopup(true)
        } else {
          console.error("Upload failed:", result.error);
          alert("Upload failed:", result.error)
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    };

    const handleIconDeleteImage = () => {
      setFormData((prev) => ({
        ...prev,
        InstituteIcon: "", // Clear image
      }));

      setIsDeletingIconPopup(false)
    };

    const handleToggleIconUpload = () => {
      if (!isUploadingIcon) {
        setIsUploadingIcon(true);
        iconInputRef.current.value = '';
        iconInputRef.current.click();
      } else {
        setFormData(prev => ({
          ...prev,
          InstituteIcon: previousImageUrl, // or a separate previousIconUrl if needed
        }));
        setIsUploadingIcon(false);
        setTempIconFile(null);
      }
    };
    
    const handleIconSelection = (e) => {
      const file = e.target.files[0];
      if (file) {
        setTempIconFile(file);
        const previewUrl = URL.createObjectURL(file);
        setFormData(prev => ({
          ...prev,
          InstituteIcon: previewUrl,
        }));
      }
    };
    
    const handleConfirmIconUpload = async () => {
      if (!tempIconFile) return;
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("InstituteIcon", tempIconFile);
    
        const response = await fetch(`${BaseUrl}/api/NewInstitute/UpdateInstituteIconImages/${InstituteId}`, {
          method: "POST",
          body: formDataToSend,
        });
    
        const result = await response.json();
        if (response.ok) {
          setFormData(prev => ({
            ...prev,
            InstituteIcon: `${BaseUrl}/api/images/InstituteBanner?url=${result.path}`,
          }));
          setIsUploadingIcon(false);
          setTempIconFile(null);
          setIsUpdatedPopup(true);
        } else {
          alert("Upload failed");
        }
      } catch (error) {
        console.error("Error uploading icon:", error);
      }
    };

    const [socialMediaErrors, setSocialMediaErrors] = useState({
      Youtube: null,
      Tiktok: null,
      Facebook: null,
      Instagram: null,
    });
    

    const validateSocialLink = (platform, url) => {
      const patterns = {
        Youtube: /^https?:\/\/(www\.)?(youtube\.com|youtu\.be)\/.+$/,
        Tiktok: /^https?:\/\/(www\.)?tiktok\.com\/.+$/,
        Facebook: /^https?:\/\/(www\.)?facebook\.com\/.+$/,
        Instagram: /^https?:\/\/(www\.)?instagram\.com\/.+$/,
      };
    
      return patterns[platform]?.test(url) ?? false;
    };
    
    // const handleChange = (e) => {
    //   const { name, value } = e.target;
    //   setFormData(prev => ({
    //     ...prev,
    //     [name]: value
    //   }));
    // };

    const handleChange = (e) => {
      const { name, value } = e.target;
    
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    
      const isValid = validateSocialLink(name, value);
      setSocialMediaErrors((prev) => ({
        ...prev,
        [name]: isValid ? null : "Invalid URL format",
      }));
    };
    
    const handleUpdateField = async (field) => {
      const value = formData[field];
    
      try {
        const response = await fetch(`${BaseUrl}/api/NewInstitute/UpdateInstituteSocialLinks/${InstituteId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ field, value }), // Example: { field: "Tiktok", value: "https://tiktok.com/..." }
        });
    
        const result = await response.json();
    
        if (response.ok) {
          setIsUpdatedPopup(true);
        } else {
          console.error(result);
          alert(`Error updating ${field}`);
        }
      } catch (error) {
        console.error('Update error:', error);
        alert(`Error updating ${field}`);
      }
    };
    
  return (
    <div className="w-[95%] bg-[#F8FAFA] rounded-[10px] flex flex-col gap-[10px] p-[20px]">
      {/* Institute/ Bussiness Name*/}
      <div
        className="w-full flex justify-between items-center pb-[20px]"
        style={{ borderBottom: '1px solid #CECECE' }}
      >
        <div className="flex flex-col gap-[5px]">
            
            <p className="text-[22px] text-[#2D2366] font-bold">Business Name</p>
            <p className="text-[22px] text-[#2D2366] mt-[5px]">{formData?.BussinessName}</p>
        </div>
      </div>
      
      {/* Institute Logo Upload */}
      <div
        className="w-full flex justify-between items-center pb-[20px]"
        style={{ borderBottom: '1px solid #CECECE' }}
      >
        <div className="flex flex-col gap-[5px]">
            <div
            className="w-[90px] h-[90px] rounded-full overflow-hidden"
            >
                <img
                      src={formData.InstituteLogo}
                      alt="img"
                      className="w-full h-full object-cover"
                    /> 
            </div>
            <p className="text-[22px] text-[#2D2366] font-bold">Institute Logo</p>
        </div>
       
        <div className="flex items-center gap-[15px]">
            {isUploadingImage ? (
            <>
                <p onClick={handleToggleImageUpload} className="text-[20px] text-[#A1A3EF] cursor-pointer">
                Cancel
                </p>
                <button
                onClick={handleConfirmUpload}
                className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-white text-[20px] cursor-pointer"
                >
                Update
                </button>
            </>
            ) : (
            <>
                {/* <button
                // onClick={handleDeleteImage}
                onClick={() => setIsDeletingPopup(true)} // <-- Add this line
                className="w-[43px] h-[43px] flex justify-center items-center rounded-[9px] bg-[#F8F8F8] cursor-pointer"
                style={{ border: "1px solid #D7D7D7" }}
                >
                <img src={deleteIcon} alt="deleteIcon" />
                </button> */}
                <button
                onClick={handleToggleImageUpload}
                className="w-[127px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-white text-[20px] cursor-pointer"
                >
                <img src={UploadIcon} alt="UploadIcon" />
                Upload
                </button>
            </>
            )}
        </div>

        {/* ✅ Always present input */}
        <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleImageSelection}
        style={{ display: 'none' }}
        />
      </div>

      {/* Institute Icon Upload */}
      <div
        className="w-full flex justify-between items-center pb-[20px]"
        style={{ borderBottom: '1px solid #CECECE' }}
      >
            <div className="flex flex-col gap-[5px]">
                <div
                className="w-[60px] h-[60px] rounded-full overflow-hidden"
                >
                    <img
                            src={formData.InstituteIcon}
                            alt="img"
                            className="w-full h-full object-cover"
                        /> 
                </div>
                <p className="text-[22px] text-[#2D2366] font-bold">Institute Icon</p>
            </div>
        
            <div className="flex items-center gap-[15px]">
                {isUploadingIcon ? (
                <>
                    <p onClick={handleToggleIconUpload} className="text-[20px] text-[#A1A3EF] cursor-pointer">
                    Cancel
                    </p>
                    <button
                    onClick={handleConfirmIconUpload}
                    className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-white text-[20px] cursor-pointer"
                    >
                    Update
                    </button>
                </>
                ) : (
                <>
                    {/* <button
                    // onClick={handleDeleteImage}
                    onClick={() => setIsDeletingIconPopup(true)} // <-- Add this line
                    className="w-[43px] h-[43px] flex justify-center items-center rounded-[9px] bg-[#F8F8F8] cursor-pointer"
                    style={{ border: "1px solid #D7D7D7" }}
                    >
                    <img src={deleteIcon} alt="deleteIcon" />
                    </button> */}
                    <button
                    onClick={handleToggleIconUpload}
                    className="w-[127px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-white text-[20px] cursor-pointer"
                    >
                    <img src={UploadIcon} alt="UploadIcon" />
                    Upload
                    </button>
                </>
                )}
            </div>

            {/* ✅ Always present input */}
            <input type="file" accept="image/*" ref={iconInputRef} onChange={handleIconSelection} hidden />

            {/* <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleImageSelection}
                style={{ display: 'none' }}
            /> */}
      </div>


        {/* Contacts */}
        <div className="w-full flex justify-between items-center py-[20px]"
            style={{borderBottom: "1px solid #CECECE"}}>
            <div className="flex flex-col gap-[0px]">
                <p className="text-[20px] text-[#2D2366] font-bold">Contacts</p>
                <p className="text-[20px] text-[#2D2366] mt-[10px]">Phone: {formData.phone}</p>
                <p className="text-[20px] text-[#2D2366]">Email: {formData.email}</p>
            </div>

            <div>
                <button 
                disabled
                className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#DCDEF6] text-[#FFFFFF] text-[20px] cursor-not-allowed">
                   Edit
                </button>
            </div>
        </div>

        {/* Address */}
        <div className="w-full flex justify-between items-center py-[20px]"
            style={{borderBottom: "1px solid #CECECE"}}>
            <div className="flex flex-col gap-[0px]">
                <p className="text-[20px] text-[#2D2366] font-bold ">Address</p>
                <p className="text-[20px] text-[#2D2366] mt-[10px]">Postal Code: {formData.postalCode}</p>
                <p className="text-[20px] text-[#2D2366]">Country: {formData.country}</p>
                <p className="text-[20px] text-[#2D2366]">Province: {formData.province}</p>
                <p className="text-[20px] text-[#2D2366]">City: {formData.city}</p>
                <p className="text-[20px] text-[#2D2366]">Address: {formData.address}</p>
            </div>

            <div>
                <button 
                disabled
                className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#DCDEF6] text-[#FFFFFF] text-[20px] cursor-not-allowed">
                   Edit
                </button>
            </div>
        </div>

         {/* Institute Banner */}
         <div className="w-full flex justify-between items-center py-[20px]"
            style={{borderBottom: "1px solid #CECECE"}}>
            <div className="flex flex-col gap-[15px]">
                <p className="text-[20px] text-[#2D2366] font-bold">Institute Banner</p>
                    <div
                        className="w-[189px] h-[101px] rounded-[15px] overflow-hidden"
                        >
                        <img
                            src={formData.InstituteBanner}
                            alt="img"
                            className="w-full h-full object-cover"
                        /> 
                    </div>
            </div>

            <div>
                <button 
                disabled
                className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#DCDEF6] text-[#FFFFFF] text-[20px] cursor-not-allowed">
                   Edit
                </button>
            </div>
        </div>

         {/* Social Media Links */}
         <p className="text-[22px] text-[#2D2366] font-bold">Social Media Links</p>

         <div className="flex flex-col mt-[10px]">
              {socialMediaErrors.Youtube && <p className="text-[#FF0000]">{socialMediaErrors.Youtube}</p>}
             <p className="text-[20px] font-bold">Youtube</p>
             <div className="w-full flex items-center gap-[20px]">
                    <input
                        type="text"
                        id="Youtube"
                        name="Youtube"
                        value={formData.Youtube}
                        onChange={handleChange} // ← important
                        className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                    />

                <button 
                    onClick={() => handleUpdateField("Youtube")}
                    disabled={
                      !!socialMediaErrors.Youtube || 
                      !formData.Youtube || 
                      formData.Youtube === originalData.Youtube
                    }
                    // className="w-[120px] h-[42px] cursor-pointer flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px]"
                    className={`w-[120px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] text-[#FFFFFF] text-[20px] ${
                      !!socialMediaErrors.Youtube || !formData.Youtube || formData.Youtube === originalData.Youtube ? 'cursor-not-allowed bg-[#DCDEF6]' : 'cursor-pointer bg-[#A1A3EF]'
                    }`}
                    >
                   {InstituteDetails?.InstituteData?.Youtube ? 'Change' : 'Add'}
                </button>
             </div>
         </div>

         <div className="flex flex-col  mt-[5px]">
              {socialMediaErrors.Tiktok && <p className="text-[#FF0000]">{socialMediaErrors.Tiktok}</p>}
             <p className="text-[20px] font-bold">Tiktok</p>
             <div className="w-full flex items-center gap-[20px]">
                    <input
                        type="text"
                        id="Tiktok"
                        name="Tiktok"
                        value={formData.Tiktok}
                        onChange={handleChange} // ← important
                        className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                    />

                <button 
                    onClick={() => handleUpdateField("Tiktok")}
                    // disabled={!!socialMediaErrors.Tiktok || !formData.Tiktok}
                    disabled={
                      !!socialMediaErrors.Tiktok || 
                      !formData.Tiktok || 
                      formData.Tiktok === originalData.Tiktok
                    }
                    // className="w-[120px] h-[42px] cursor-pointer flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px]">
                    className={`w-[120px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] text-[#FFFFFF] text-[20px] bg-[#A1A3EF] ${
                      !!socialMediaErrors.Tiktok || !formData.Tiktok  || formData.Tiktok === originalData.Tiktok ? 'cursor-not-allowed bg-[#DCDEF6]' : 'cursor-pointer bg-[#A1A3EF]'
                    }`}
                    >
                   {InstituteDetails?.InstituteData?.Tiktok ? 'Change' : 'Add'}
                </button>
             </div>
         </div>

         <div className="flex flex-col  mt-[5px]">
         {socialMediaErrors.Facebook && <p className="text-[#FF0000]">{socialMediaErrors.Facebook}</p>}
             <p className="text-[20px] font-bold">Facebook</p>
             <div className="w-full flex items-center gap-[20px]">
                    <input
                        type="text"
                        id="Facebook"
                        name="Facebook"
                        value={formData.Facebook}
                        onChange={handleChange} // ← important
                        className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                    />

                <button 
                    onClick={() => handleUpdateField("Facebook")}
                    // disabled={!!socialMediaErrors.Facebook || !formData.Facebook}
                    disabled={
                      !!socialMediaErrors.Facebook || 
                      !formData.Facebook || 
                      formData.Facebook === originalData.Facebook
                    }
                    // className="w-[120px] h-[42px] cursor-pointer flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px]">
                    className={`w-[120px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] text-[#FFFFFF] text-[20px] bg-[#A1A3EF] ${
                      !!socialMediaErrors.Facebook || !formData.Facebook  || 
                      formData.Facebook === originalData.Facebook ? 'cursor-not-allowed bg-[#DCDEF6]' : 'cursor-pointer bg-[#A1A3EF]'
                    }`}
                    >
                        {InstituteDetails?.InstituteData?.Facebook ? 'Change' : 'Add'}
                </button>
             </div>
         </div>

         <div className="flex flex-col  mt-[5px]">
            {socialMediaErrors.Instagram && <p className="text-[#FF0000]">{socialMediaErrors.Instagram}</p>}
             <p className="text-[20px] font-bold">Instagram</p>
             <div className="w-full flex items-center gap-[20px]">
                    <input
                        type="text"
                        id="Instagram"
                        name="Instagram"
                        value={formData.Instagram}
                        onChange={handleChange} // ← important
                        className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                    />

                <button 
                    onClick={() => handleUpdateField("Instagram")}
                    // disabled={!!socialMediaErrors.Instagram || !formData.Instagram}
                    disabled={
                      !!socialMediaErrors.Instagram || 
                      !formData.Instagram || 
                      formData.Instagram === originalData.Instagram
                    }
                    // className="w-[120px] h-[42px] cursor-pointer flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px]">
                    className={`w-[120px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] text-[#FFFFFF] text-[20px] bg-[#A1A3EF] ${
                      !!socialMediaErrors.Instagram || !formData.Instagram || 
                      formData.Instagram === originalData.Instagram ? 'cursor-not-allowed bg-[#DCDEF6]' : 'cursor-pointer bg-[#A1A3EF]'
                    }`}
                   >
                     {InstituteDetails?.InstituteData?.Instagram ? 'Change' : 'Add'}
                </button>
             </div>
         </div>

      {isUpdatedPopup && (
        <ReuseablePopup
          setShowPopup={setIsUpdatedPopup}
          heading="Congratulations !!"
          text="Changes saved successfully."
          btnText="Done"
          onClick={() => setIsUpdatedPopup(false)} // <-- Add this line
          imageSrc={require("../Assets/SuccessAssets.svg").default} // ✅ Dynamic image source
        />
      )}

      {isDeletingPopup && (
        <ReuseablePopup
          setShowPopup={setIsDeletingPopup}
          heading="Delete"
          text="Are you sure you want to delete the image?"
          btnText="Delete"
          onClick={handleDeleteImage} // <-- Add this line
          imageSrc={require("../Assets/DeletePopup.svg").default} // ✅ Dynamic image source
        />
      )}

      {isDeletingIconPopup && (
        <ReuseablePopup
          setShowPopup={setIsDeletingIconPopup}
          heading="Delete"
          text="Are you sure you want to delete the image?"
          btnText="Delete"
          onClick={handleIconDeleteImage} // <-- Add this line
          imageSrc={require("../Assets/DeletePopup.svg").default} // ✅ Dynamic image source
        />
      )}

    </div>
  );
};


export default InstituteDetails;
